/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from "react";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./ProfilShow.scss";
import ProfilBarShow from "Components/ProfilBar/ProfilBarShow/ProfilBarShow";
import { Divider } from "primereact/divider";
import { useFetchGet } from "Services/api";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../Services/functions";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import axios from "axios";
import crown from "assets/crown.png";

/**
 * Permet d'afficher la page de détails du profil d'une personne sélectionnée dans l'annuaire
 * Un utilisateur peut aussi avoir un aperçu de cette page pour son profil via "aperçu du profil" dans /profil
 * Accessible pour tous les utilisateurs
 */
const ProfilShow = (props) => {
  const { id } = useParams();
  const userData = useFetchGet(
    id == props.auth.userConnected.id ? `/users/${id}/private` : `/users/${id}`,
    props.auth.token
  );

  const downloadRPResume = () => {
    let cvId = userData.data.resume.id;
    if (!cvId) {
      props.auth.toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Cet utilisateur n'a pas de CV",
        life: 5000,
      });
      return;
    }
    let url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${cvId}/pdf`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${props.auth.token}`,
          accept: "application/json",
        },
        responseType: "blob",
      })
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res.data);
        let filename =
          res.headers["content-disposition"]?.split("filename=")[1];
        // On supprime ce qu'il y a après le '.pdf' dans le nom du fichier
        filename = filename?.split(".pdf")[0];
        // On supprime les guillemets
        filename = filename?.replace(/"/g, "");
        link.setAttribute("download", filename || "cv.pdf");
        link.click();
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div className="profil_show">
      <Header>
        <div className="profilPage__headerProfilBar">
          {props.auth.isConnected && userData.loaded && (
            <ProfilBarShow user={userData.data} />
          )}
        </div>
      </Header>
      <div className="profil_show__container">
        {props.auth.isConnected && (
          <>
            <div className="profil_show__container__column">
              <div className="profil_show__container__article">
                <div className="profil_show__container__article__title">
                  <h1 className="h1_trait_dessus">Formations et diplômes</h1>
                </div>
                <div className="profil_show__container__article__container">
                  {userData.loaded &&
                    userData.data.resume &&
                    userData.data.resume.educations
                      ?.sort(
                        (a, b) =>
                          new Date(a?.startDate) - new Date(b?.startDate)
                      )
                      ?.sort(
                        (a, b) =>
                          new Date(a?.endDate || Date.now()) -
                          new Date(b?.endDate || Date.now())
                      )
                      ?.sort((a, b) => a?.current - b?.current)
                      ?.map((education) => {
                        if (education?.certified)
                          return (
                            <div
                              className="profil_show__container__article__container__experience"
                              key={education.id}
                            >
                              {/* Seuls les diplômes sont certifiés (et pas les formations) */}
                              {education?.obtainedDiplome && (
                                <img src={crown} />
                              )}
                              <h4>
                                {education?.current
                                  ? education?.currentEtape?.label
                                  : education?.obtainedDiplome?.label}
                              </h4>
                              <p>
                                {education?.current
                                  ? "En cours"
                                  : education?.startDate
                                  ? new Date(
                                      education?.startDate
                                    )?.getFullYear() +
                                    " - " +
                                    new Date(education?.endDate)?.getFullYear()
                                  : new Date(education?.endDate)?.getFullYear()}
                              </p>
                              <div className="profil_show__container__article__container__experience__item">
                                {/* Seuls les diplômes sont certifiés (et pas les formations) */}
                                {education?.obtainedDiplome &&
                                  "Diplôme certifié"}
                                <br />
                                {props.auth.universityConnected?.label}
                                <br />
                                {education?.domain}
                              </div>
                              <p>
                                <span>{education?.studyLevel}</span>
                              </p>
                              <Divider />
                            </div>
                          );
                        else
                          return (
                            <div
                              className="profil_show__container__article__container__experience"
                              key={education.id}
                            >
                              <h4>{education.diploma}</h4>
                              <p>
                                {formatDate(education.startDate, "/")} -{" "}
                                {formatDate(education.endDate, "/")}{" "}
                              </p>
                              <div className="profil_show__container__article__container__experience__item">
                                {education.school}
                                <br />
                                {education.domain}
                              </div>
                              <p>
                                <span>{education.studyLevel}</span>
                              </p>
                              <Divider />
                            </div>
                          );
                      })}
                </div>
              </div>
            </div>
            <div className="profil_show__container__article">
              <div className="profil_show__container__article__title">
                <h1 className="h1_trait_dessus">
                  Expériences professionnelles
                </h1>
              </div>
              <div className="profil_show__container__article__container__exp">
                {userData.loaded &&
                  userData.data.resume &&
                  userData.data.resume.experiences
                    ?.sort(
                      (a, b) => new Date(a?.startDate) - new Date(b?.startDate)
                    )
                    ?.sort(
                      (a, b) =>
                        new Date(a?.endDate || Date.now()) -
                        new Date(b?.endDate || Date.now())
                    )
                    ?.sort((a, b) => a?.current - b?.current)
                    .map((xp) => (
                      <div
                        className="profil_show__container__article__container__exp__experience"
                        key={xp.id}
                      >
                        <h4>
                          {xp.company} - {xp.city}
                        </h4>
                        <p>
                          {formatDate(xp.startDate, "/")} -{" "}
                          {xp.current
                            ? "aujourd'hui"
                            : formatDate(xp.endDate, "/")}
                        </p>
                        <div className="profil_show__container__article__container__exp__experience__item">
                          <h5>
                            <strong>Poste occupé</strong> :{" "}
                          </h5>
                          <p>{xp.jobname}</p>
                        </div>
                        <div className="profil_show__container__article__container__exp__experience__item">
                          <h5>
                            <strong>Secteur</strong> :{" "}
                          </h5>
                          <p>{xp.sector?.label || xp.sector}</p>
                        </div>
                        <div className="profil_show__container__article__container__exp__experience__item">
                          <h5>
                            <strong>Domaine</strong> :{" "}
                          </h5>
                          <p>{xp.domain?.label || xp.domain}</p>
                        </div>
                        <div className="profil_show__container__article__container__exp__experience__item">
                          <h5>
                            <strong>Contrat</strong> :{" "}
                          </h5>
                          <p>{xp.typeOfContract?.label || xp.typeOfContract}</p>
                        </div>
                        {xp.description && (
                          <div className="profil_show__container__article__container__exp__experience__item">
                            <h5>
                              <strong>Description</strong> :{" "}
                            </h5>
                            <p>{xp.description}</p>
                          </div>
                        )}
                        <Divider />
                      </div>
                    ))}
              </div>
            </div>
            <div className="profil_show__container__article mobile">
              <div className="profil_show__container__article__title">
                <h1 className="h1_trait_dessus">Compétences</h1>
              </div>
              <div className="profil_show__container__article__container__competences">
                {userData.loaded &&
                  userData.data.resume &&
                  userData.data.resume.skills.map((item) => (
                    <div className="competence" key={item.id}>
                      <h4>{item.skill}</h4>
                    </div>
                  ))}
              </div>
            </div>
            <div className="profil_show__container__article desktop">
              <div className="profil_show__container__article__title">
                <h1 className="h1_trait_dessus">Compétences</h1>
              </div>
              <div className="profil_show__container__article__container__competences">
                {userData.loaded &&
                  userData.data.resume &&
                  userData.data.resume.skills.map((item) => (
                    <div className="competence" key={item.id}>
                      <h4>{item.skill}</h4>
                    </div>
                  ))}
              </div>
            </div>
          </>
        )}
      </div>
      {userData.loaded && userData.data.resume && (
        <BtnBleu
          btnAction={() => {
            downloadRPResume();
          }}
        >
          Télécharger le CV Réseau Pro
        </BtnBleu>
      )}
      <Footer />
    </div>
  );
};

ProfilShow.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilShow);
